import { render } from "./IncallTicketsBlock.vue?vue&type=template&id=28cb160f&scoped=true"
import script from "./IncallTicketsBlock.vue?vue&type=script&lang=js"
export * from "./IncallTicketsBlock.vue?vue&type=script&lang=js"

import "./IncallTicketsBlock.vue?vue&type=style&index=0&id=28cb160f&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28cb160f"]])

export default __exports__